import toast from "react-hot-toast";
import { callApi } from "../../services/ApiServices";
import {
  validateNumeric,
  validateRequired,
  ErrorMessage,
} from "../../utlis/function";
import { useRef, useState } from "react";
import { useGlobalStates } from "../../utlis/ClubsContext";
import CommonLoader from "../common/CommonLoader";

const AddClubPricingForm = ({
  formData,
  updateFormData,
  errors,
  setErrors,
  handleInputChange,
  activeStep,
  steps,
  handleNext,
  setCompletedStep,
  completedStep,
  setIsDirty,
  isDirty,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { clubId } = useGlobalStates();
    const fieldsRef = useRef({})
  
  const validateField = (name, value) => {
    switch (name) {
      // 15sec Duration fields
      case "duration15sec1Month":
        if (!validateRequired(value)) return "1 Month price is required";
        return !validateNumeric(value) ? "Please enter a valid amount" : "";
      case "duration15sec6Month":
        if (!validateRequired(value)) return "6 Month price is required";
        return !validateNumeric(value) ? "Please enter a valid amount" : "";
      case "duration15sec12Month":
        if (!validateRequired(value)) return "12 Month price is required";
        return !validateNumeric(value) ? "Please enter a valid amount" : "";

      // 30sec Duration fields
      case "duration30sec1Month":
        if (!validateRequired(value)) return "1 Month price is required";
        return !validateNumeric(value) ? "Please enter a valid amount" : "";
      case "duration30sec6Month":
        if (!validateRequired(value)) return " 6 Month price is required";
        return !validateNumeric(value) ? "Please enter a valid amount" : "";
      case "duration30sec12Month":
        if (!validateRequired(value)) return "12 Month price is required";
        return !validateNumeric(value) ? "Please enter a valid amount" : "";

      // Daypart fields
      case "daypartOpen10AM":
        if (!formData.dayPartStatus) return "";
        if (!validateRequired(value)) return "Price is required";
        return !validateNumeric(value) ? "Please enter a valid amount" : "";
      case "daypart10AMto4PM":
        if (!formData.dayPartStatus) return "";
        if (!validateRequired(value)) return "Price is required";
        return !validateNumeric(value) ? "Please enter a valid amount" : "";
      case "daypart4PMClose":
        if (!formData.dayPartStatus) return "";
        if (!validateRequired(value)) return "Close price is required";
        return !validateNumeric(value) ? "Please enter a valid amount" : "";
      case "daypartWeekendsOnly":
        if (!formData.dayPartStatus) return "";
        if (!validateRequired(value)) return "Price is required";
        return !validateNumeric(value) ? "Please enter a valid amount" : "";
      case "dp10AmLimit":
      case "dp10_4Limit":
      case "dp4PmLimit":
      case "dpWeekendAmLimit":
        if (!formData.dayPartStatus) return "";
        if (!validateRequired(value)) return "Limit is required";

      // Geo Targeting fields
      case "geoTargetingSetupFee":
        if (!formData.geoTargetingRadioButton) return "";
        if (!validateRequired(value)) return "One-time setup fee is required";
        return !validateNumeric(value) ? "Please enter a valid fee amount" : "";
      case "geoTargetingMonthlyFee":
        if (!formData.geoTargetingRadioButton) return "";
        if (!validateRequired(value))
          return "Monthly recurring fee is required";
        return !validateNumeric(value) ? "Please enter a valid fee amount" : "";

      // Design Service fields
      case "designServiceFee":
        if (!formData.designServiceRadioButton) return "";
        // if (!validateRequired(value)) return "One-time design fee is required";
        // return !validateNumeric(value) ? "Please enter a valid fee amount" : "";

      default:
        return "";
    }
  };

  const handleFieldValidation = (name, value) => {
    const error = validateField(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const validateAllFields = () => {
    let isValid = true;
    const newErrors = {};

    // Get all field names from validation logic
    const fieldsToValidate = [
      "duration15sec1Month",
      "duration15sec6Month",
      "duration15sec12Month",
      "duration30sec1Month",
      "duration30sec6Month",
      "duration30sec12Month",
      "daypartOpen10AM",
      "daypart10AMto4PM",
      "daypart4PMClose",
      "daypartWeekendsOnly",
      "geoTargetingSetupFee",
      "geoTargetingMonthlyFee",
      "designServiceFee",
      "dp10AmLimit",
      "dp10_4Limit",
      "dp4PmLimit",
      "dpWeekendAmLimit",
    ];

    fieldsToValidate.forEach((fieldName) => {
      const error = validateField(fieldName, formData[fieldName] || "");
      if (error) {
        newErrors[fieldName] = error;
        isValid = false;
      }
    });

    setErrors((prev) => ({
      ...prev,
      ...newErrors,
    }));

    return {isValid, newErrors};
  };

  const saveFormData = async () => {
    if (!isDirty) {
      toast("No changes to save");
      return;
    }
    let data = {
      geoTargetStatus: formData.geoTargetingRadioButton,
      ...(formData.geoTargetingRadioButton && {
        geoTargetFee: Number(formData.geoTargetingSetupFee),
        geoTargetRecFee: Number(formData.geoTargetingMonthlyFee),
      }),

      designServiceStatus: formData.designServiceRadioButton,
      ...(formData.designServiceRadioButton && {
        designServiceFee: Number(formData.designServiceFee),
      }),

      clubHandleDesign: formData.clubHandleDesign,
        drsDesignSupport: formData.drsDesignSupport,
      pricings: [
        {
          durationType: "sec",
          duration: 15,
          price1Mon: Number(formData.duration15sec1Month),
          price6Mon: Number(formData.duration15sec6Month),
          price12Mon: Number(formData.duration15sec12Month),
          daypartStatus: false,
        },
        {
          durationType: "sec",
          duration: 30,
          price1Mon: Number(formData.duration30sec1Month),
          price6Mon: Number(formData.duration30sec6Month),
          price12Mon: Number(formData.duration30sec12Month),
          daypartStatus: formData.dayPartStatus,

          ...(formData.dayPartStatus && {
            dp10AmPercentage: formData.daypartOpen10AM,
            dp10AmLimit: formData.dp10AmLimit,
            dp10_4Percentage: formData.daypart10AMto4PM,
            dp10_4Limit: formData.dp10_4Limit,
            dp4PmPercentage: formData.daypart4PMClose,
            dp4PmLimit: formData.dp4PmLimit,
            dpWeekendPercentage: formData.daypartWeekendsOnly,
            dpWeekendAmLimit: formData.dpWeekendAmLimit,
          }),
        },
      ],
    };
    setIsLoading(true);
    // console.log("data", data)
    try {
      const response = await callApi({
        method: "put",
        url: `club/pricing/create/${clubId}`,
        data: data,
      });
      if (response.status === 200) {
        toast.success("Club data saved successfully!");
        setCompletedStep((prev) => Math.max(prev, response?.stepUpdated || 3));
        setIsDirty(false);
      }
      console.log("response api", response);
      return response;
    } catch (error) {
      console.error("Error saving club data:", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };
   const scrollToFirstError = (errors) => {
  const findError = (obj) => {
    for (const key in obj) {
      if (typeof obj[key] === "string" && obj[key]) {
        return key;
      }
      if (typeof obj[key] === "object") {
        const nested = findError(obj[key]);
        if (nested) return key;
      }
    }
    return null;
  };

  const firstErrorField = findError(errors);

  if (firstErrorField && fieldsRef.current[firstErrorField]) {
    fieldsRef.current[firstErrorField].scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    fieldsRef.current[firstErrorField].focus?.();
  }
};


  const handleSaveWithAPI = async () => {
    const {isValid, newErrors}  = validateAllFields();
    if (!isValid) {
      scrollToFirstError(newErrors)
      return;
    }

    try {
      const response = await saveFormData();
    } catch (error) {
      console.error("Error saving club:", error);
    }
  };

  const handleNextWithAPI = async () => {
    const { isValid, newErrors } = validateAllFields();
    if (!isValid) {
      scrollToFirstError(newErrors);
      return;
    }
    if (isDirty) {
      try {
        const response = await saveFormData();
        if (response.status === 200) {
          handleNext();
        }
      } catch (error) {
        console.error("Error saving club:", error);
      }
    } else {
      handleNext();
    }
  };

  return (
    <div className="space-y-6">
      {isLoading && <CommonLoader fullScreen />}
      {/* 15sec Duration Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <h2 className="text-xl font-medium text-black tracking-[0] leading-[normal] mb-2">
          15sec Duration
        </h2>
        <p className="text-base font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
          Set pricing for short-format ad spots across different subscription
          plans.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* 1 Month */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
               Month to Month
            </label>
            <input
            ref={(el)=>(fieldsRef.current.duration15sec1Month = el)}
              type="number"
              placeholder="Enter amount"
              value={formData.duration15sec1Month || ""}
              name="duration15sec1Month"
              maxLength={30}
              onChange={(e) => {
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.duration15sec1Month
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
            />
            <ErrorMessage message={errors.duration15sec1Month} />
          </div>

          {/* 6 Month */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              6 Month Commitment
            </label>
            <input
            ref={(el)=>(fieldsRef.current.duration15sec6Month = el)}
              type="number"
              placeholder="Enter amount"
              value={formData.duration15sec6Month || ""}
              name="duration15sec6Month"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.duration15sec6Month
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
            />
            <ErrorMessage message={errors.duration15sec6Month} />
          </div>

          {/* 12 Month */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              12 Month Commitment
            </label>
            <input
            ref={(el)=>(fieldsRef.current.duration15sec12Month = el)}
              type="number"
              placeholder="Enter amount"
              value={formData.duration15sec12Month || ""}
              name="duration15sec12Month"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.duration15sec12Month
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
            />
            <ErrorMessage message={errors.duration15sec12Month} />
          </div>
        </div>
      </div>

      {/* 30sec Duration Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <h2 className="text-xl font-medium text-black tracking-[0] leading-[normal] mb-2">
          30 sec Duration
        </h2>
        <p className="text-base font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
          Define pricing for extended ad playback across multiple plans.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* 1 Month */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Month to Month
            </label>
            <input
            ref={(el)=>(fieldsRef.current.duration30sec1Month = el)}
              type="number"
              placeholder="Enter amount"
              value={formData.duration30sec1Month || ""}
              name="duration30sec1Month"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.duration30sec1Month
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
            />
            <ErrorMessage message={errors.duration30sec1Month} />
          </div>

          {/* 6 Month */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              6 Month Commitment
            </label>
            <input
            ref={(el)=>(fieldsRef.current.duration30sec6Month = el)}
              type="number"
              placeholder="Enter amount"
              value={formData.duration30sec6Month || ""}
              name="duration30sec6Month"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.duration30sec6Month
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
            />
            <ErrorMessage message={errors.duration30sec6Month} />
          </div>

          {/* 12 Month */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              12 Month Commitment
            </label>
            <input
            ref={(el)=>(fieldsRef.current.duration30sec12Month = el)}
              type="number"
              placeholder="Enter amount"
              value={formData.duration30sec12Month || ""}
              name="duration30sec12Month"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.duration30sec12Month
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
            />
            <ErrorMessage message={errors.duration30sec12Month} />
          </div>
        </div>
      </div>

      {/* Daypart Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <div className="flex items-center justify-between mt-4">
          <h2 className="text-xl font-medium text-black tracking-[0] leading-[normal] mb-2">
            Daypart
          </h2>
          <button
            onClick={() =>
              updateFormData({
                dayPartStatus: !formData.dayPartStatus,
              })
            }
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
              formData.dayPartStatus ? "bg-primary" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                formData.dayPartStatus ? "translate-x-5" : "translate-x-0.5"
              }`}
            />
          </button>
        </div>
        <p className="text-base font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
          Adjust pricing based on time-of-day and high-traffic viewing windows.
        </p>
        {formData.dayPartStatus && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Open 10:00AM */}
            <div>
              <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                Open 10:00AM
              </label>
              <input
              ref={(el)=>(fieldsRef.current.daypartOpen10AM = el)}
                type="text"
                 placeholder="Enter discount %"
                value={formData.daypartOpen10AM || ""}
                name="daypartOpen10AM"
                onChange={(e) => {
                   const value = e.target.value
                if(value.length > 10) return
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                  errors.daypartOpen10AM ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.daypartOpen10AM} />
            </div>

            <div>
              <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                Ads Limit
              </label>
              <input
              ref={(el)=>(fieldsRef.current.dp10AmLimit = el)}
                type="number"
                placeholder="Enter ads limit"
                value={formData.dp10AmLimit || ""}
                name="dp10AmLimit"
                onChange={(e) => {
                   const value = e.target.value
                if(value.length > 10) return
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                  errors.dp10AmLimit ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.dp10AmLimit} />
            </div>

            {/* 10:00AM - 04:00PM */}
            <div>
              <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                10:00AM - 04:00PM
              </label>
              <input
              ref={(el)=>(fieldsRef.current.daypart10AMto4PM = el)}
                type="number"
                placeholder="Enter discount %"
                value={formData.daypart10AMto4PM || ""}
                name="daypart10AMto4PM"
                onChange={(e) => {
                   const value = e.target.value
                if(value.length > 10) return
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                  errors.daypart10AMto4PM ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.daypart10AMto4PM} />
            </div>

            <div>
              <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                Ads Limit
              </label>
              <input
              ref={(el)=>(fieldsRef.current.dp10_4Limit = el)}
                type="number"
               placeholder="Enter ads limit"
                value={formData.dp10_4Limit || ""}
                name="dp10_4Limit"
                onChange={(e) => {
                   const value = e.target.value
                if(value.length > 10) return
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                  errors.dp10_4Limit ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.dp10_4Limit} />
            </div>

            {/* 04:00PM Close */}
            <div>
              <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                04:00PM Close
              </label>
              <input
              ref={(el)=>(fieldsRef.current.daypart4PMClose = el)}
                type="number"
                 placeholder="Enter discount %"
                value={formData.daypart4PMClose || ""}
                name="daypart4PMClose"
                onChange={(e) => {
                   const value = e.target.value
                if(value.length > 10) return
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                  errors.daypart4PMClose ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.daypart4PMClose} />
            </div>

            <div>
              <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                Ads Limit
              </label>
              <input
              ref={(el)=>(fieldsRef.current.dp4PmLimit = el)}
                type="number"
                placeholder="Enter ads limit"
                value={formData.dp4PmLimit || ""}
                name="dp4PmLimit"
                onChange={(e) => {
                   const value = e.target.value
                if(value.length > 10) return
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                  errors.dp4PmLimit ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.dp4PmLimit} />
            </div>

            {/* Weekends Only */}
            <div>
              <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                Weekends Only
              </label>
              <input
              ref={(el)=>(fieldsRef.current.daypartWeekendsOnly = el)}
                type="number"
                 placeholder="Enter discount %"
                value={formData.daypartWeekendsOnly || ""}
                name="daypartWeekendsOnly"
                onChange={(e) => {
                   const value = e.target.value
                if(value.length > 10) return
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                  errors.daypartWeekendsOnly
                    ? "border-red-500"
                    : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.daypartWeekendsOnly} />
            </div>
            <div>
              <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                Ads Limit
              </label>
              <input
              ref={(el)=>(fieldsRef.current.dpWeekendAmLimit = el)}
                type="number"
               placeholder="Enter ads limit"
                value={formData.dpWeekendAmLimit || ""}
                name="dpWeekendAmLimit"
                onChange={(e) => {
                   const value = e.target.value
                if(value.length > 10) return
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                  errors.dpWeekendAmLimit ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.dpWeekendAmLimit} />
            </div>
          </div>
        )}
      </div>

      {/* Geo Targeting Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <div className="flex items-center justify-between mt-4">
          <h2 className="text-xl font-medium text-black tracking-[0] leading-[normal] mb-2">
            Geo Targeting
          </h2>
          <button
            onClick={() =>
              updateFormData({
                geoTargetingRadioButton: !formData.geoTargetingRadioButton,
              })
            }
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
              formData.geoTargetingRadioButton ? "bg-primary" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                formData.geoTargetingRadioButton
                  ? "translate-x-5"
                  : "translate-x-0.5"
              }`}
            />
          </button>
        </div>
        {formData.geoTargetingRadioButton && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            {/* One-time Setup Fee */}
            <div>
              <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                One-time Setup Fee
              </label>
              <input
              ref={(el)=>(fieldsRef.current.geoTargetingSetupFee = el)}
                type="number"
                placeholder="Enter fee"
                value={formData.geoTargetingSetupFee || ""}
                name="geoTargetingSetupFee"
                onChange={(e) => {
                   const value = e.target.value
                if(value.length > 10) return
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                  errors.geoTargetingSetupFee
                    ? "border-red-500"
                    : "border-gray-200"
                }`}
              />
              {formData.geoTargetingRadioButton && (
                <ErrorMessage message={errors.geoTargetingSetupFee} />
              )}
            </div>

            {/* Monthly Recurring Fee */}
            <div>
              <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                Monthly Recurring Fee
              </label>
              <input
              ref={(el)=>(fieldsRef.current.geoTargetingMonthlyFee = el)}
                type="number"
                placeholder="Enter fee"
                value={formData.geoTargetingMonthlyFee || ""}
                name="geoTargetingMonthlyFee"
                onChange={(e) => {
                   const value = e.target.value
                if(value.length > 10) return
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                  errors.geoTargetingMonthlyFee
                    ? "border-red-500"
                    : "border-gray-200"
                }`}
              />
              {formData.geoTargetingRadioButton && (
                <ErrorMessage message={errors.geoTargetingMonthlyFee} />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Design Service Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <div className="flex items-center justify-between mt-4">
          <h2 className="text-xl font-medium text-black tracking-[0] leading-[normal] mb-2">
            Design Service
          </h2>
          <button
            onClick={() =>
              updateFormData({
                designServiceRadioButton: !formData.designServiceRadioButton,
                clubHandleDesign : !formData.clubHandleDesign ,
                 drsDesignSupport: !formData.drsDesignSupport 

              })
            }
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
              formData.designServiceRadioButton ? "bg-primary" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                formData.designServiceRadioButton
                  ? "translate-x-5"
                  : "translate-x-0.5"
              }`}
            />
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          {/* One-time Design Fee */}
          <div>
            {formData.designServiceRadioButton && (
              <>
                <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
                  One-time Professional Ad Design
                </label>
                <input
                ref={(el)=>(fieldsRef.current.designServiceFee = el)}
                  type="number"
                  placeholder="Enter fee"
                  value={formData.designServiceFee || ""}
                  name="designServiceFee"
                  onChange={(e) => {
                     const value = e.target.value
                if(value.length > 10) return
                    handleInputChange(e);
                    handleFieldValidation(e.target.name, e.target.value);
                  }}
                  className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                    errors.designServiceFee
                      ? "border-red-500"
                      : "border-gray-200"
                  }`}
                />
              </>
            )}
            {formData.designServiceRadioButton && (
              <ErrorMessage message={errors.designServiceFee} />
            )}
          </div>
        </div>
      </div>

      {/* Club Handle Design Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-medium text-black tracking-[0] leading-[normal] mb-2">
              Club Handle Design
            </h2>
            <p className="text-base font-normal text-textcolor tracking-[0] leading-[20px]">
              The club is responsible for delivering finished ad files for all
              campaigns.,
            </p>
          </div>
          <button
            onClick={() =>
              updateFormData({ 
                clubHandleDesign: !formData.clubHandleDesign,
                designServiceRadioButton: !formData.designServiceRadioButton,
                drsDesignSupport: !formData.drsDesignSupport
               })
            }
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
              formData.clubHandleDesign ? "bg-primary" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                formData.clubHandleDesign ? "translate-x-5" : "translate-x-0.5"
              }`}
            />
          </button>
        </div>

        {/* DRS Design Support Section */}
        <div className="flex items-center justify-between mt-4">
          <div>
            <h2 className="text-xl font-medium text-black tracking-[0] leading-[normal] mb-2">
              DRS Design Support
            </h2>
            <p className="text-base font-normal text-textcolor tracking-[0] leading-[20px]">
              DRS will produce professional ad creative on behalf of
              advertisers. Additional design fees may apply.
            </p>
          </div>
          <button
            onClick={() =>
              updateFormData({ 
                drsDesignSupport: !formData.drsDesignSupport,
                designServiceRadioButton: !formData.designServiceRadioButton,
                clubHandleDesign : !formData.clubHandleDesign

               })
            }
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
              formData.drsDesignSupport ? "bg-primary" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                formData.drsDesignSupport ? "translate-x-5" : "translate-x-0.5"
              }`}
            />
          </button>
        </div>
      </div>
      <div className="flex items-center justify-between mt-6">
        <button
          onClick={handleSaveWithAPI}
          disabled={isLoading}
          className="cursor-pointer px-2 h-[60px] w-[200px] border border-primary text-primary font-medium text-lg rounded-full transition-colors hover:bg-primary hover:text-white"
        >
          Save
        </button>
        <button
          onClick={handleNextWithAPI}
          disabled={isLoading}
          className="cursor-pointer px-2 h-[60px] w-[200px] border bg-primary hover:bg-hover text-white rounded-full text-primary font-medium text-lg transition-colors"
        >
          {activeStep === steps.length - 1 ? "Save" : "Next"}
        </button>
      </div>
    </div>
  );
};

export default AddClubPricingForm;
